/** LocalStorage keys used across Advance Outlet Invoicing */
export const LS_IS_CALL_GET_ALL_VEHICLE =
  "isCallGetAllVehicleApiAtOutletinvoicing";
export const LS_IS_SHOW_OFFER_BUTTON = "isShowOfferButtonAtBillingPreview";
export const LS_IS_RATE_EDITABLE_HORECA = "isRateEditableForHoreca";
export const LS_STOCK_LIST = "stockList";
export const LS_IS_SHOW_BILL_DISCOUNT_AND_CD =
	"isShowBillDiscountAndCDAtManualOrderBilling";
export const LS_SHOW_DISCOUNT_AMT_EDITABLE =
	"showDiscountAmtEditableAtManualOrderBilling";

/** Default localStorage fallbacks */
export const DEFAULT_VEHICLE_API_FLAG = "0";
export const DEFAULT_SHOW_OFFER_BUTTON = "0";
export const DEFAULT_DISCOUNT_SETTING_FLAG = "0";
